<template>
	<div ref="content-gate-overlay" class="c-content-gate" :class="{'--fullwidth-overlay' : bookmarksConnected, 'shown' : contentGateIsShown }">
		<div ref="content-gate-modal" class="c-content-gate__wrapper">
			<button
				v-if="contentGateIsShown"
				type="button"
				class="c-content-gate__button--close"
				@click="setContentGateIsShown(false)"
			>
				&#x2715;
			</button>
			<slot></slot>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapMutations } from 'vuex';
	import { track_show_gated_content } from 'shared/services/tracking/contentTrackingService';

	export default {
		name: 'content-gate',
		props: {
			isContentGateEnabled: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				documentHeight: 0,
				elementHeight: {
					header: 0,
					breadcrumbs: 0,
					banner: 0,
					footer: 0,
				},
			};
		},
		computed: {
			...mapGetters({
				contentGateIsShown: 'getContentGateIsShown',
				bookmarksConnected: 'getBookmarksConnected',
			}),
		},
		watch: {
			contentGateIsShown(newValue) {
				if (!this.bookmarksConnected) {
					if (newValue === true) {
						this.handleResize();
						this.scrollModalIntoView();
					} else if (newValue === false) {
						this.resetStyles();
					}
				}
				else if (newValue === false) {
					this.setBookmarksConnected(false);
				}
			},
		},
		mounted() {
			window.addEventListener('resize', this.handleResize);
			document.onreadystatechange = () => {
				if (document.readyState === 'complete') {
					this.handleResize();
					this.handleTracking();
				}
			};
		},
		beforeUnmount() {
			window.removeEventListener('resize', this.handleResize);			
		},
		methods: {
			...mapMutations(['setContentGateIsShown', 'setBookmarksConnected']),
			handleResize() {
				if (this.isContentGateEnabled || (this.contentGateIsShown && !this.bookmarksConnected)) {
					this.setHeightValues();
					this.setStyles();
				}
			},
			setHeightValues() {
				this.documentHeight = document.body
					? Math.max(document.body.scrollHeight, document.body.offsetHeight, document.body.clientHeight)
					: 0;
				this.elementHeight.header = document.querySelector('header')
					? document.querySelector('header').clientHeight
					: 0;
				this.elementHeight.breadcrumbs = document.querySelector('.c-breadcrumb')
					? document.querySelector('.c-breadcrumb').clientHeight
					: 0;
				this.elementHeight.banner = document.querySelector('.c-hero')
					? document.querySelector('.c-hero').clientHeight
					: 0;
				this.elementHeight.footer = document.querySelector('footer')
					? document.querySelector('footer').clientHeight
					: 0;
			},
			setStyles() {
				let elementsHeight = Object.values(this.elementHeight).reduce((sum, elem) => sum + elem);
				this.$refs['content-gate-overlay'].style.top = `${elementsHeight - this.elementHeight.footer}px`;
				this.$refs['content-gate-overlay'].style.height = `${this.documentHeight - elementsHeight}px`;
				this.$refs['content-gate-overlay'].style.display = 'flex';
			},
			resetStyles() {
				this.$refs['content-gate-overlay'].style.top = '-999px';
				this.$refs['content-gate-overlay'].style.height = '0';
				this.$refs['content-gate-overlay'].style.display = 'none';
			},
			scrollModalIntoView() {
				this.$refs['content-gate-modal'].scrollIntoView({
					behavior: 'smooth',
					block: 'end',
					inline: 'nearest',
				});
			},
			handleTracking() {
				if (this.isContentGateEnabled && !this.bookmarksConnected) {
					// new GA4 tracking:
					track_show_gated_content();
				}
			},
		},
	};
</script>
